export namespace Regex {
  export const PHONE_NUMBER = {
    CA: /^[0-9+ ()-]+$/,
    Default: /^[0-9+ ]+$/,
  };
}
